<template>
  <v-chip v-if="role" prepend-icon="$user" density="comfortable" :color="userRoleColor(role)" label>
    <span class="text-high-emphasis">{{ $t(`userRole.${role}`) }}</span>
  </v-chip>
</template>

<script setup lang="ts">
defineProps<{
  role: UserRole | LogUserType
}>()
</script>
